import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import lodash from "lodash";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

import { withStyles } from "@mui/styles";
import { useTheme, withTheme } from '@emotion/react';


import Section from "./section";

import defaultMetadata from "../../defaultMetadata";

const styles = (theme) => {return {
    eventsContainer: {
        overflow: "auto",
        wordWrap: "break-word",
        maxHeight: "var(--events-container-max-height, 400px)",

        [theme.breakpoints.down('sm')]: {
            maxHeight: 400,
        }
    },
    itemContainer: {
        alignItems: "flex-start",
        paddingLeft: 0,
        paddingRight: 0,
    },
    singleEventContainer: {
        borderColor: defaultMetadata.theme.colors.border,
        borderWidth: 1,
        borderRadius: 3,
        borderStyle: "solid",
        width: "100%",
        display: "block",
        boxSizing: "border-box",
    },
    coverImageContainer: {
        position: "relative",
        height: 200,
        overflow: "hidden",
    },
    coverImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center",
    },
    eventContentContainer: {
        padding: 16,
        display: "flex",
        alignItems: "flex-start",
    },
    eventCalendar: {
        flex: 0,
        marginRight: 16,
        textAlign: "center",
        padding: 12,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: defaultMetadata.theme.colors.rosyPink,
    },
    eventMonth: {
        color: defaultMetadata.theme.colors.rosyPink,
        textTransform: "uppercase",
        fontSize: 10,
        fontWeight: 600,
    },
    eventContent: {
        width: "calc(100% - 64px)",
    },
}};

class UpcomingEvents extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            events: []
        };
    }

    componentDidMount() {
        axios.get("https://syneos.almaconnect.com//api/events.json").then((response) => {
            this.setState({events: this.state.events.concat(response.data.data)});
        });
    }

    renderSingleEvent = (event, key) => {
        const {classes} = this.props;
        const {
            subject,
            event_url: url,
            start_date_month: eventMonth,
            start_date_day: eventDay,
            short_description: shortDescription,
            cover_picture: {url: imageUrl},
            contributor: {name: contributorName}
        } = event;

        return (
            <ListItem key={key} className={classes.itemContainer}>
                <a href={url} className={classes.singleEventContainer}>
                    <div className={classes.coverImageContainer}>
                        <img src={imageUrl} alt="" className={classes.coverImage} />
                    </div>
                    <div className={classes.eventContentContainer}>
                        <div className={classes.eventCalendar}>
                            <div className={classes.eventMonth}>{eventMonth}</div>
                            <div className="text_title">{eventDay}</div>
                        </div>
                        <div className={classes.eventContent}>
                            <div className="ellipsis text_heading ac_link width-100">
                                {subject}
                            </div>
                            <div className="ellipsis text_caption_small width-100 line-height-1-5">
                                {shortDescription}
                            </div>
                            <div className="ellipsis text_caption width-100 margin-top-4">
                                <span className="text_caption">Created by&nbsp;</span>
                                <span className="text_caption_dark">{contributorName}</span>
                            </div>
                        </div>
                    </div>
                </a>
            </ListItem>
        );
    };

    renderEvents = () => {
        let eventsComponent = null;

        if (lodash.isEmpty(this.state.events)) {
            eventsComponent = (
                <div className="text-align-center padding-32-80">
                    No events found...
                </div>
            );
        } else {
            eventsComponent = this.state.events.map(this.renderSingleEvent);
        };

        return (
            <List>
                {eventsComponent}
            </List>
        );
    };

    render() {
        const {classes, scrollHeight} = this.props;

        const containerStyle = scrollHeight ? {'--events-container-max-height': `${scrollHeight}px`} : {};

        const viewAllUrl = "https://syneos.almaconnect.com/event_calendar";
        return (
            <Section
                sectionHeading="Events"
                action={{name: "View All", url: viewAllUrl}}
            >
                <div className={classes.eventsContainer} style={containerStyle}>
                    {this.renderEvents()}
                </div>
            </Section>
        );
    }
}


UpcomingEvents.propTypes = {
    scrollHeight: PropTypes.number,
    style: PropTypes.object,
    metadata: PropTypes.shape({
        networkBaseUrl: PropTypes.string.isRequired,
        upcomingEvents: PropTypes.shape({
            enabled: PropTypes.bool,
        }).isRequired
    }).isRequired
}

export default withStyles(styles, {withTheme: true})(withTheme((UpcomingEvents)));